import { Button } from "./Button";

// Two-step destructive action. First click "arms" (turns into a red
// "Confirm remove" / custom label), second click fires onConfirm. A
// third party — the parent — owns the armed state and clears it after
// confirm so only one row is armed at a time. We went this route to
// stop relying on window.confirm(), which some browser extensions /
// lockdown scripts (SES, MetaMask, etc.) suppress silently, making
// Delete buttons appear broken.
export function RemoveButton({
  armed,
  onArm,
  onConfirm,
  label = "Remove",
  confirmLabel = "Confirm remove",
  disabled = false,
  title,
}: {
  armed: boolean;
  onArm: () => void;
  onConfirm: () => void;
  label?: string;
  confirmLabel?: string;
  disabled?: boolean;
  title?: string;
}) {
  if (armed) {
    return (
      <button
        type="button"
        onClick={onConfirm}
        disabled={disabled}
        className="inline-flex items-center justify-center font-medium rounded-md px-2.5 py-1 text-sm bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
        title={title ?? "Click again to confirm"}
      >
        {confirmLabel}
      </button>
    );
  }
  return (
    <Button size="sm" variant="ghost" onClick={onArm} disabled={disabled} title={title}>
      {label}
    </Button>
  );
}
